export interface IServiceToken {
    id: number;
    name: string;
    /** Wird serverseitig erzeugt und ist nur lesbar. */
    token: string;
    /** Kommaseparierte Berechtigungen, z. B. "extension,release". */
    scopes: string;
    can_write: boolean;
    is_active: boolean;
    note: string;
    created_at: string;
    last_used_at: string | null;
}

export const SERVICE_SCOPES = [
    { value: "extension", title: "Erweiterungen" },
    { value: "release", title: "Changelogs" },
];
